export default __webpack_public_path__ + "static/media/Opposites03_03.1f1e3392.png";